import { useState, useEffect } from "react";
import { GOOGLE_API_KEY } from "../../../utils/constant";

const useGeocoding = (latitude, longitude, apiKey = GOOGLE_API_KEY) => {
  const [address, setAddress] = useState(null);
  const [error, setError] = useState(null);

  const performReverseGeocoding = async (latitude, longitude) => {
    try {
      // Construct the API request URL for reverse geocoding
      const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`;

      // Make a GET request to the reverse geocoding API
      const response = await fetch(apiUrl);
      const data = await response.json();

      // Check if the response status is OK
      if (data.status === "OK") {
        // Extract the formatted address from the first result
        console.log(data.results)
        const addressComponents = data.results[0].formatted_address;
        const address = addressComponents
        // .filter((component) => component.types.includes("locality") || component.types.includes("administrative_area_level_1") || component.types.includes("country"))
        // .map((component) => component.long_name)
        // .join(", ");
        return { address };
      } else {
        return { error: `Error in reverse geocoding request: ${data.status}` };
      }
    } catch (error) {
      return { error: `Error in reverse geocoding request: ${error.message}` };
    }
  };

  useEffect(() => {
    // Ensure that both latitude and longitude are provided
    if ((latitude && longitude) || address) {
      setError("Latitude and longitude are required.");
      return;
    }
    let apiUrl;
    // Construct the API request URL
    if (latitude && longitude) {
      // Forward geocoding: Convert latitude and longitude to an address
      apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`;
    } else {
      // Reverse geocoding: Convert address to latitude and longitude
      apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`;
    }
    // Make a GET request to the API
    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        console.log("Address:", data.display_name);

        // Check if the response status is OK
        if (data.status === "OK") {
          // Extract the formatted address from the first result
          const address = data.results[0].formatted_address;
          console.log('address',address)
          setAddress(address);
        } else {
          setError(`Error in geocoding request: ${data.status}`);
        }
      })
      .catch((error) => {
        setError(`Error in geocoding request: ${error.message}`);
      });
  }, [latitude, longitude,address, apiKey]);

  // return { address, error };
  return { address, error,setAddress, performReverseGeocoding };

};

export default useGeocoding;
